window.filterDropdownMultiselect = function (selected, options, label) {
    let options_values = Object.keys(options)
    let options_count = options_values.length

    return {
        selected,
        options,

        open: false,

        reset () {
            if (this.isAllSelected) {
                this.selected = []
            } else {
                this.selected = Object.keys(this.options)
            }
        },

        get isAllSelected () {
            return this.selected.length === options_count
        },

        get displayText () {
            if (this.isAllSelected) {
                return 'Alle ' + label
            }

            let subject_count = this.selected.length || 0
            if (subject_count === 1) {
                return 'Nur ' + this.options[this.selected[0]]
            }

            if (subject_count === options_count - 1) {
                return 'Alle ' + label + ' bis auf "' +
                    options_values.
                        filter(item => this.selected.indexOf(item) === -1).
                        map(item => this.options[item]).
                        join('') + '"'
            }

            if (subject_count > options_count / 2) {
                return 'Alle ' + label + ' bis auf ' +
                    (options_count - subject_count)
            }

            return subject_count.toString() + ' ' + label
        },
    }
}
